import { render, staticRenderFns } from "./IdMaintenance.vue?vue&type=template&id=e1488554"
import script from "./IdMaintenance.vue?vue&type=script&lang=ts"
export * from "./IdMaintenance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports